import gql from 'graphql-tag';

export default gql`
  query flightItemTranslationsQuery {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        configurations {
          seatsAvailabilityThreshold
        }
        allegiantBundleIcons: images(section: "allegiantBundleIcons") {
          id
          title
          alt
          path
          __typename
        }
        bundleCoverImages: images(section: "bundleCoverImages") {
          id
          title
          alt
          path
          __typename
        }
      }
    }
  }
`;
